import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';
import styled, { css } from 'styled-components';

type Props = {
  children?: never;
  isUpdating: boolean;
  onBulkUpdate: (e: React.MouseEvent<HTMLButtonElement>) => Promise<void>;
  onCancelPreview: (e: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ActionButtons: React.FC<Props> = ({
  isUpdating,
  onBulkUpdate,
  onCancelPreview,
}) => {
  const { t } = useTranslation();

  return (
    <OuterWrapper>
      <InnerWrapper marginSide="right">
        <Button onClick={onCancelPreview}>
          {t('text.user.index.cancelPreview')}
        </Button>
      </InnerWrapper>
      <InnerWrapper marginSide="left">
        <Button
          disabled={isUpdating}
          loading={isUpdating}
          onClick={onBulkUpdate}
          primary={true}
        >
          {t('text.user.index.bulkUpdate')}
        </Button>
      </InnerWrapper>
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 24px 0;

  && {
    button + button {
      margin-left: 24px;
    }
  }
`;

const InnerWrapper = styled.div<{ marginSide: 'right' | 'left' }>`
  display: flex;
  justify-content: center;
  margin: 24px 0;

  ${({ marginSide }) => css`
    margin-${marginSide}: 48px;
  `}

  && {
    button + button {
      margin-left: 24px;
    }
  }
`;
